import { useCallback } from 'react';
import { useFormContext } from '../contexts/FormContext';
import { useContactExtraction } from './useContactExtraction';
import { useAnalyticsTracking } from './useAnalyticsTracking';
import { useSessionLogging } from './useSessionLogging';
import { logger } from '../utils/logger';

export const useContactSubmission = () => {
  const { activeForm } = useFormContext();
  const { extractContactData, hasValidContactData } = useContactExtraction();
  const { trackFormCompletion } = useAnalyticsTracking();
  const { logContactToSessionIfValid } = useSessionLogging();

  const processContactSubmission = useCallback(async (submittedFormData: { [key: string]: string }) => {
    logger.log('🔥 Processing contact submission');
    
    // Extract contact data for lead push
    const contactData = extractContactData(submittedFormData);
    
    // Get the source data for session logging
    const sourceData = (submittedFormData as any).formData || submittedFormData;
    
    // Extract interest data
    let interestData;
    const rawInterestData = (submittedFormData as any).interestData;
    
    if (typeof rawInterestData === 'string') {
      try {
        interestData = JSON.parse(rawInterestData);
      } catch (error) {
        logger.log('🔥 Failed to parse interestData string, using as-is:', rawInterestData);
        interestData = rawInterestData;
      }
    } else {
      interestData = rawInterestData;
    }

    const formType = activeForm?.toLowerCase() || 'contact';
    
    // Track analytics
    trackFormCompletion(formType, contactData, interestData);
    
    // Log to session
    logContactToSessionIfValid(formType, contactData, sourceData);

    return {
      contactData,
      interestData,
      sourceData,
      formType,
      hasValidContact: hasValidContactData(contactData)
    };
  }, [activeForm, extractContactData, trackFormCompletion, logContactToSessionIfValid, hasValidContactData]);

  return {
    processContactSubmission
  };
};